import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=475d67dc&scoped=true&"
import script from "./AttachmentUpload.vue?vue&type=script&lang=ts&"
export * from "./AttachmentUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentUpload.vue?vue&type=style&index=0&id=475d67dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d67dc",
  null
  
)

export default component.exports